export default __webpack_public_path__ + "static/media/WpdLogoOnly.12ea53f3.svg";